
import { defineComponent, computed } from 'vue'
import { store } from '@/store'
import RouteThumbnail from '@/components/routes/RouteThumbnail.vue'

export default defineComponent({
  name: 'RouteLimitExceeded',
  components: { RouteThumbnail },
  setup() {
    const user = store.user.get(state => state)
    const plan = store.user.get(state => state.subscription.plan)
    const routes = computed(() => store.user.getUserRoutes())
    const limit = computed(() => plan.value.permissions.LIMIT_ROUTES)

    return { user, routes, limit, plan }
  }
})
